import { render, staticRenderFns } from "./userGroup.vue?vue&type=template&id=7b577e92&scoped=true"
import script from "./userGroup.vue?vue&type=script&lang=ts"
export * from "./userGroup.vue?vue&type=script&lang=ts"
import style0 from "./userGroup.vue?vue&type=style&index=0&id=7b577e92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b577e92",
  null
  
)

export default component.exports